import React, { useEffect } from "react"

import PropTypes from "prop-types"

import Iframe from "../../atoms/iframe"

const NewsletterArchive = ({ newsletter }) => {
  let isMounted = false

  const updateDimensions = () => {
    if (isMounted) {
      document.querySelector('[title="activeNewsletter"]').style.height = `${
        window.innerHeight -
        document.getElementsByTagName("header")[0].offsetHeight
      }px`
    }
  }

  useEffect(() => {
    isMounted = true
    updateDimensions()
    window.addEventListener("resize", updateDimensions)

    return function cleanup() {
      isMounted = false
      window.removeEventListener("resize", updateDimensions)
    }
  }, [])

  return <Iframe title="activeNewsletter" height="800px" url={newsletter} />
}

export default NewsletterArchive

NewsletterArchive.propTypes = {
  newsletter: PropTypes.string.isRequired,
}
